export class Notification {
  notificationId!: string
  date!: string
  resourceKey!: string
  title!: string
  text!: string
  madeBy!: string
  madeByName!: string
  isSeen!: boolean
  objectId!: string
  notificationType!: NotificationType
}
export class NotificationsModel {
  unSeenNotificationsCount!: number;
  pageData!: Notification[];
  pageNumber!: number;
  pageSize!: number;
  totalCount!: number;
}
export enum NotificationType {
  Request_Update = 'Request_Update',
}
